<template>
    <div class="content-scroll">
        <div class="content-box">
            <el-tabs active-name="first">
                <el-tab-pane :label="curData.name" name="first"></el-tab-pane>
            </el-tabs>
            <el-button size="small" class="posTopBtn" type="success" @click="handleForm(false)">新增</el-button>
            <div class="bmzd-box page">
                <div class="bmzd-left">
                    <el-table @sort-change="sortChange" :data="pageData" v-loading="tLoading" border>
                        <el-table-column :show-overflow-tooltip="true" prop="id" label="ID"
                                         width="70"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="name" label="名称"></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注"></el-table-column>
                        <el-table-column label="操作" width="120" align="right">
                            <template slot-scope="scope">
                                <el-button icon="el-icon-edit" title="编辑" type="success" size="mini"
                                           @click="handleForm(true, scope.row)"></el-button>
                                <el-button icon="el-icon-delete" title="删除" type="danger" :loading="bLoading"
                                           size="mini" @click="handleDel(scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="toolbar" style="text-align: right;">
                        <el-pagination @current-change="handleCurrentChange" background
                                       :current-page="filters.pageIndex" :page-size="filters.pageSize"
                                       layout="total, prev, pager, next" :total="totalNum"></el-pagination>
                    </div>
                </div>
                <div class="bmzd-right">
                    <el-tree :data="treeData" :default-expanded-keys="[curData.code]" :current-node-key="curData.code"
                             :default-checked-keys="[curData.code]" node-key="code" ref="tree" :props="defaultProps"
                             @node-click="nodeClick"></el-tree>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="aVisible" width="50%" :modal-append-to-body="true" :close-on-click-modal="false"
                   top="5%">
            <div class="solt-header">
                <h2>{{ saveType ? '编码字典编辑':'编码字典新增' }}</h2>
            </div>
            <el-form :model="formData" v-loading="fLoading" ref="formFileds" :rules="formRules" label-width="120px">
                <el-form-item label="名称：" prop="name">
                    <el-input type="text" v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="上级节点：">
                    <el-input type="text" disabled v-model="curData.name"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input type="textarea" :rows="2" v-model="formData.remark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="aVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveType ? formSubmit(updateUrl) : formSubmit(addUrl)"
                               :loading="bLoading">提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'bmzd',
        data() {
            return {
                pageUrl: '/dictionaries/list/page', //编码字典接口
                addUrl: "/dictionaries/saveOrUpdate", //新增保存接口
                updateUrl: "/dictionaries/saveOrUpdate", //编辑保存接口
                deleteUrl: "/dictionaries/remove", //编辑保存接口

                // form
                formData: {
                    name: '',
                    type: 'CUSTOMER_TYPE',
                    remark: '',
                },
                formRules: {
                    name: [{required: true, message: '请输入名称', trigger: 'blur'}]
                },
                filters: {
                    type: 'CUSTOMER_TYPE',
                    pageSize: 10,
                    pageIndex: 1,
                },

                treeData: [
                    {
                        name: '客户统一管理平台', code: 0, children: [
                            {name: '客户类型', code: 'CUSTOMER_TYPE'},
                            {name: '客户等级', code: 'CUSTOMER_LEVEL'},
                            {name: '客户来源', code: 'CUSTOMER_SOURCE'},
                            {name: '跟踪状态', code: 'CUSTOMER_TRACK_STATUS'},
                            {name: '产品类型', code: 'PRODUCT_TYPE'},
                            {name: '客户状态', code: 'CUSTOMER_STATUS'},
                        ]
                    }
                ],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                curData: {
                    name: '客户类型',
                    code: 'CUSTOMER_TYPE',
                },


            }
        },

        methods: {
            nodeClick(data, node) {
                this.curData = data
                this.formData.type = data.code
                this.filters.type = data.code
                this.getPage()
            },
            formSubmit(url) {
                this.$refs.formFileds.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认保存或提交吗？', '提示', {}).then(() => {
                            this.request(url, this.formData, (data) => {
                                this.$message({message: '保存或提交成功', type: 'success'})
                                this.getPage();
                                this.aVisible = false
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        })
                    }
                })
            },
        },
        created() {
            this.getPage();
        }
    }
</script>

<style lang="less">
    .bmzd-box {
        top: 50px;

        .bmzd-left {
            position: absolute;
            left: 0;
            bottom: 0;
            top: 0;
            right: 240px;
        }

        .bmzd-right {
            position: absolute;
            right: 0;
            bottom: 0;
            top: 0;
            width: 220px;
            border: #ddd 1px solid;
        }
    }
</style>